<template>
  <div class="eol-container-box">
    <div class="search-all-box">
      <a-form-model layout="inline" ref="ruleForm" :model="form">
        <a-form-model-item prop="complete_type">
          <a-select
            v-model="form.complete_type"
            placeholder="作业提交形式"
            style="width: 150px"
            class="multiple-select"
            dropdownClassName="multipleDrop"
          >
            <a-select-option value="">作业提交形式</a-select-option>
            <a-select-option
              v-for="(item, index) in completeArr"
              :key="index"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="name">
          <a-input
            v-model="form.name"
            class="search-input"
            style="width: 180px"
            placeholder="请输入作业提交人姓名"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item prop="class_id">
          <a-select
            v-model="form.class_id"
            placeholder="请选择实践班级"
            style="width: 160px"
            class="multiple-select"
            dropdownClassName="multipleDrop"
          >
            <a-select-option value="">请选择实践班级</a-select-option>
            <a-select-option
              v-for="(item, index) in classArr"
              :key="index"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="teacher_name">
          <a-input
            v-model="form.teacher_name"
            style="width: 150px"
            class="search-input"
            placeholder="请输入批阅人"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item prop="approve_status">
          <a-select
            v-model="form.approve_status"
            placeholder="请选择批阅状态"
            style="width: 150px"
            class="multiple-select"
            dropdownClassName="multipleDrop"
          >
            <a-select-option value="">请选择批阅状态</a-select-option>
            <a-select-option
              v-for="(item, index) in readArr"
              :key="index"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="work_type">
          <a-select
            v-model="form.work_type"
            placeholder="请选择作业类型"
            style="width: 150px"
            class="multiple-select"
            dropdownClassName="multipleDrop"
          >
            <a-select-option value="">请选择作业类型</a-select-option>
            <a-select-option
              v-for="(item, index) in workArr"
              :key="index"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="search-btn" type="primary" @click="onSearch"
            >搜索</a-button
          >
          <a-button class="reset-btn" @click="resetForm">重置</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="right-option-box">
        <a-button class="option-btn" type="primary" @click="exportData"
          >导出成绩</a-button
        >
        <a-button class="option-btn" type="primary" @click="exportAttach"
          >导出作业附件</a-button
        >
      </div>
    </div>

    <div class="table-all-box">
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        @change="tableOnChange"
        :bordered="false"
        size="small"
        :pagination="false"
      >
        <template slot="complete_type" slot-scope="text, scope">
          <span
            :class="['type-icon', scope.complete_type == 2 ? 'twin' : '']"
          ></span
          >{{ scope.complete_type == 1 ? "个人" : "小组" }}完成
        </template>
        <template slot="work_type" slot-scope="text, scope">
          {{ scope.work_type == 1 ? "大学生微电影" : "大学生讲思政课" }}
        </template>
        <template slot="approve_name" slot-scope="text, scope">
          {{
            scope.approve_status == 3
              ? scope.teacher_name
              : scope.approve_status == 2
              ? "系统批阅"
              : ""
          }}
        </template>
        <template slot="status" slot-scope="status">
          <span v-if="status == 1" class="noread">待批阅</span>
          <span v-else>已批阅</span>
        </template>
        <template slot="action" slot-scope="text, scope">
          <a-button type="link" @click="routeSkip(scope)">批阅</a-button>
          <a-button type="link" @click="exportAttach(scope)"
            >导出作业附件</a-button
          >
          <a-button type="link" @click="handleCasePush(scope)"
            >案例推优</a-button
          >
        </template>
      </a-table>

      <a-pagination
        class="school-pagination"
        v-model="page"
        :total="totalNum"
        @change="pageChange"
        show-less-items
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import services from "../../../assets/js/services";
export default {
  name: "activityCreate",
  components: {},
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        class_id: "",
        name: "",
        complete_type: "",
        teacher_name: "",
        approve_status: "",
        work_type: "",
      },
      classArr: [],
      readArr: [
        { id: 1, name: "待批阅" },
        { id: 2, name: "已批阅" },
      ],
      completeArr: [
        { id: 1, name: "个人完成" },
        { id: 2, name: "小组完成" },
      ],
      workArr: [
        { id: 1, name: "大学生微电影" },
        { id: 2, name: "大学生讲思政课" },
      ],
      columns: [
        {
          title: "作业提交形式",
          dataIndex: "complete_type",
          scopedSlots: { customRender: "complete_type" },
          width: "110px",
        },
        {
          title: "作业提交人",
          dataIndex: "created_name",
        },
        {
          title: "所属实践班级",
          dataIndex: "class_name",
          width: "110px",
        },
        {
          title: "作业类型",
          dataIndex: "work_type",
          scopedSlots: { customRender: "work_type" },
        },
        {
          title: "提交时间",
          dataIndex: "work_time",
          minWidth: "100px",
        },
        {
          title: "批阅人",
          dataIndex: "teacher_name",
          scopedSlots: { customRender: "approve_name" },
          width: "100px",
        },
        {
          title: "满分",
          dataIndex: "total_score",
          width: "70px",
        },
        {
          title: "原始成绩",
          dataIndex: "score",
          sorter: (a, b) => a.score - b.score,
          width: "120px",
        },
        {
          title: "百分制成绩",
          dataIndex: "percent_score",
          sorter: (a, b) => a.percent_score - b.percent_score,
          width: "120px",
        },
        {
          title: "批阅状态",
          align: "center",
          dataIndex: "approve_status",
          scopedSlots: { customRender: "status" },
          width: "80px",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: "200px",
        },
      ],
      task_id: "t007",
      activity_id: "",
      order: "score", // 排序字段
      order_by: "", // 正序asc 倒叙desc
    };
  },
  computed: {
    ...mapState({
      activityInfo: (state) => state.activityStat.activityInfo,
    }),
  },
  mounted() {
    this.activity_id = this.$route.query.id;
    this.getClassList();
    this.getTableList();
  },
  methods: {
    ...mapActions([
      "getSchoolActivityClasses",
      "getSchoolTaskWorkList",
      "getSchoolTaskExportScore",
      "getSchoolTaskExportAttach",
      "getSchoolTaskDownAttach",
    ]),
    handleCasePush(item) {
      window.open(
        `/${this.school_code}/school/case/casepushform?work_id=${item.id}&activity_id=${item.activity_id}&id=${item.activity_id}`,
        "_blank"
      );
    },
    getClassList() {
      this.getSchoolActivityClasses({
        activity_id: this.activity_id,
        page: 1,
        size: 100,
      }).then((res) => {
        if (res.code == "0000" && res.data) {
          this.classArr = res.data.items;
        }
      });
    },
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        task_id: this.task_id,
        activity_id: this.activity_id,
        class_id: this.form.class_id,
        name: this.form.name,
        teacher_name: this.form.teacher_name,
        approve_status: this.form.approve_status,
        work_type: this.form.work_type,
        complete_type: this.form.complete_type,
        order: this.order, // 排序字段
        order_by: this.order_by, // 正序asc 倒叙desc
      };
      this.getSchoolTaskWorkList(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    //通过field 的值进行一个判断，然后在进行排序
    tableOnChange(p, f, s) {
      this.order_by = "desc"; // 正序asc 倒叙desc
      //第一个排序
      if (s.field == "score") {
        this.order_by =
          s.order == "descend" ? "desc" : s.order == "ascend" ? "asc" : "";
        this.onSearch();
      }
    },
    // 导出成绩
    exportData() {
      let that = this;
      if (that.tableData && that.tableData.length > 0) {
        axios({
          url:
            services.HOST +
            `/api/school/train/work/${this.task_id}/export_score`,
          params: {
            activity_id: this.activity_id,
            class_id: this.form.class_id,
            name: this.form.name,
            username: this.form.username,
            mobile: this.form.mobile,
            teacher_name: this.form.teacher_name,
            approve_status: this.form.approve_status,
            order: this.order, // 排序字段
            order_by: this.order_by, // 正序asc 倒叙desc
          },
          method: "get",
          responseType: "arraybuffer",
        }).then((res) => {
          if (res) {
            let newUrl = window.URL.createObjectURL(new Blob([res.data]));
            let type = "xlsx";
            that.createUrlBlob(
              newUrl,
              `【${
                (this.activityInfo && this.activityInfo.name) || ""
              }】【创实践微影实践成绩】`,
              type
            );
          }
        });
      } else {
        that.$message.error("暂无可导出的数据");
      }
    },
    // 导出作业附件
    exportAttach(obj) {
      let that = this;
      let params = {
        task_id: this.task_id,
        activity_id: this.activity_id,
        class_id: this.form.class_id,
        name: this.form.name,
        username: this.form.username,
        mobile: this.form.mobile,
        teacher_name: this.form.teacher_name,
        approve_status: this.form.approve_status,
      };
      if (obj) {
        params.work_id = obj.id;
      }
      that.getSchoolTaskExportAttach(params).then((res) => {
        if (res.code == "0000" && res.data) {
          console.log(res.data);
          if (res.data.unique) {
            const targetRoute = this.$router.resolve({
              path: `/${that.school_code}/school/activity/download`,
              query: {
                id: that.activity_id,
                tid: that.task_id,
                unique: res.data.unique,
                url: "create",
              },
            });
            window.open(targetRoute.href, "_blank");
          }
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    // 文件流处理
    createUrlBlob(url, fileName, type) {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.setAttribute("download", `${fileName}.${type}`);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.onSearch();
    },
    routeSkip(rows) {
      this.$router.push(
        `/${this.school_code}/school/activity/create/mark?id=${this.activity_id}&work_id=${rows.id}`
      );
    },
  },
};
</script>

<style lang="less" scoped>
.type-icon {
  width: 12px;
  height: 12px;
  background: url("../../../assets/image/school/teach/one.png") no-repeat
    center/cover;
  vertical-align: -1px;
  display: inline-block;
  margin-right: 6px;
  &.twin {
    background: url("../../../assets/image/school/teach/twin.png") no-repeat
      center/cover;
  }
}
.noread {
  width: 66px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  background: #f7f0e6;
  border-radius: 12px;
  color: #7b5127;
  display: inline-block;
}
</style>
